








































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { validate } from "vee-validate";
// import {
//   IProductConfigProviderData,
//   IProductConfigProviderMethods
// } from "@/models/providers/products";
import { ProductOrderTypes } from "@/data/enums";
import { IBasketProviderData } from "@/models/providers/baskets";

@Component
export default class ProductControl extends Vue {
  // Inject
  // @Inject({ from: "productConfigProviderData" })
  // public readonly $productConfigData!: () => IProductConfigProviderData;

  // @Inject({ from: "productConfigProviderMethods" })
  // public readonly $productConfigMethods!: IProductConfigProviderMethods;

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  // Props

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: null })
  public basketProductId!: boolean;

  @Prop({ default: null })
  public configProvider!: any;

  // Data

  public inputDebounced = this.$_.debounce(this.quantityChanged, 250);

  // Computed

  // public get $product() {
  //   return this.$productConfigData();
  // }

  public get basketData() {
    return this.$basketData();
  }

  public get showQuantityControls() {
    return this.configProvider.orderType === ProductOrderTypes.QUANTITY_BASED;
  }

  public get cta() {
    return this.basketProductId
      ? this.$t("_action.update")
      : this.$store.getters["ui/isMobile"]
      ? this.$t("_action.add")
      : this.$t("_action.add_to_basket");
  }

  // Methods

  public async quantityChanged(value) {
    const result = await validate(
      this.configProvider.quantities[this.configProvider.productId],
      this.$_.concat(
        [
          `min_value:${this.configProvider.quantityStep}`,
          `divisible_by:${this.configProvider.quantityStep}`
        ],
        this.configProvider.maxQuantity
          ? [`max_value:${this.configProvider.maxQuantity}`]
          : []
      ).join("|")
    );
    if (result.valid)
      this.$set(
        this.configProvider.quantities,
        this.configProvider.productId,
        value
      );
  }
}
